'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _ = require('../');

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);

var _PropertyDetailsPlaceholder = require('./PropertyDetailsPlaceholder.scss');var styles = _interopRequireWildcard(_PropertyDetailsPlaceholder);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var PropertyDetailsPlaceholder = function (_Component) {_inherits(PropertyDetailsPlaceholder, _Component);function PropertyDetailsPlaceholder() {var _temp, _this, _ret;_classCallCheck(this, PropertyDetailsPlaceholder);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.


    getSummaryData = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var rawData = (0, _omit2.default)(data, 'propertyId');
      var directLink = !Object.keys(rawData).length;

      if (directLink) {
        return {
          price: '',
          address: {},
          additionalInfo: {} };

      }

      return Object.assign({},
      rawData, {
        price: (0, _beautifyNumber2.default)(rawData.price),
        address: {
          cityName: rawData.address && rawData.address.city_name,
          streetName: rawData.address && rawData.address.street_name,
          houseNumber: rawData.address && rawData.address.house_number },

        additionalInfo: Object.assign({},
        rawData.additionalInfo, {
          area: (0, _get2.default)(rawData, 'additionalInfo.area.base') || (0, _get2.default)(rawData, 'additionalInfo.area') }) });


    }, _temp), _possibleConstructorReturn(_this, _ret);}PropertyDetailsPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps) {return !!newProps.loaded;};PropertyDetailsPlaceholder.prototype.

  render = function render() {var _cx;var _props =
    this.props,isMobile = _props.isMobile,data = _props.data,translate = _props.translate,className = _props.className,isRtl = _props.isRtl;
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.propertyPlaceholder, styles[className], (_cx = {}, _cx[styles.mobile] = isMobile, _cx)) },
        _react2.default.createElement('div', { className: styles.galleryPlaceholder }),

        _react2.default.createElement('div', { className: styles.mainInfo },
          _react2.default.createElement('div', { className: styles.propertyInfo },
            _react2.default.createElement('div', { className: styles.propertyType },
              data && data.propertyType, '\xA0',
              !isMobile ? _react2.default.createElement('br', null) : null,
              data && data.optionType && translate('propertyType', data.optionType)),


            _react2.default.createElement(_.PropertySummary, {
              translate: translate,
              data: this.getSummaryData(data),
              className: styles.propertySummary,
              isRtl: isRtl })),



          _react2.default.createElement(_.ContactsPlaceholder, { isMobile: isMobile })),


        isMobile ? _react2.default.createElement('hr', null) : null,

        _react2.default.createElement(_.DescriptionPlaceholder, { isMobile: isMobile })));


  };return PropertyDetailsPlaceholder;}(_react.Component);


PropertyDetailsPlaceholder.propTypes = {
  translate: _propTypes2.default.func,
  className: _propTypes2.default.string,
  data: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };exports.default =


PropertyDetailsPlaceholder;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailsPlaceholder/PropertyDetailsPlaceholder.js
// module id = 2829
// module chunks = 0